import { createSlice } from '@reduxjs/toolkit';
import { initStateCreateNewMessage, reducerCreateNewMessage } from '../actions/chat/createNewMessage';
import { initStateGetChatSingle, reducerGetChatSingle } from '../actions/chat/getChatSingle';
import { initStateGetChatMessages, reducerGetChatMessages } from '../actions/chat/getChatMessages';
import { initStateSendMessage, reducerSendMessage } from '../actions/chat/sendMessage';
import { initStateGetChatList, reducerGetChatList } from '../actions/chat/getChatList';
import { initStateFindChat, reducerFindChat } from '../actions/chat/findChat';
import { initStateGetChatListStats, reducerGetChatListStats } from '../actions/chat/getChatListStats';
import { initStateDeleteChat, reducerDeleteChat } from '../actions/chat/deleteChat';
import { initStateDeleteChatList, reducerDeleteChatList } from '../actions/chat/deleteChatList';
import { initStateReadChat, reducerReadChat } from '../actions/chat/readChat';
import { initStateSetChatManager, reducerSetChatManager } from '../actions/chat/setChatManager';
import { initStateCreateMailing, reducerCreateMailing } from '../actions/chat/createMailing';
import { initStateGetMailingList, reducerGetMailingList } from '../actions/chat/getMailingList';
import { initStateGetMailingUsers, reducerGetMailingUsers } from '../actions/chat/getMailingUsers';

export const initialState = {
  ...initStateCreateNewMessage,
  ...initStateGetChatSingle,
  ...initStateGetChatMessages,
  ...initStateGetChatList,
  ...initStateSendMessage,
  ...initStateFindChat,
  ...initStateGetChatListStats,
  ...initStateDeleteChat,
  ...initStateDeleteChatList,
  ...initStateReadChat,
  ...initStateSetChatManager,
  ...initStateCreateMailing,
  ...initStateGetMailingList,
  ...initStateGetMailingUsers,
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    resetCreateNewMessage(state, action) {
      state.createNewMessage = initStateCreateNewMessage.createNewMessage;
    },
    resetGetChatSingle(state, action) {
      state.getChatSingle = initStateGetChatSingle.getChatSingle;
    },
    resetGetChatMessages(state, action) {
      state.getChatMessages = initStateGetChatMessages.getChatMessages;
    },
    resetSendMessage(state, action) {
      state.sendMessage = initStateSendMessage.sendMessage;
    },
    resetGetChatList(state, action) {
      state.getChatList = initStateGetChatList.getChatList;
    },
    resetFindChat(state, action) {
      state.findChat = initStateFindChat.findChat;
    },
    resetGetChatListStats(state, action) {
      state.getChatListStats = initStateGetChatListStats.getChatListStats;
    },
    resetDeleteChat(state, action) {
      state.deleteChat = initStateDeleteChat.deleteChat;
    },
    resetDeleteChatList(state, action) {
      state.deleteChatList = initStateDeleteChatList.deleteChatList;
    },
    resetReadChat(state, action) {
      state.readChat = initStateReadChat.readChat;
    },
    resetSetChatManager(state, action) {
      state.setChatManager = initStateSetChatManager.setChatManager;
    },
    resetCreateMailing(state, action) {
      state.createMailing = initStateCreateMailing.createMailing;
    },
    resetGetMailingUsers(state, action) {
      state.getMailingUsers = initStateGetMailingUsers.getMailingUsers;
    },
    resetGetMailingList(state, action) {
      state.getMailingList = initStateGetMailingList.getMailingList;
    },
  },
  extraReducers: {
    ...reducerCreateNewMessage,
    ...reducerGetChatSingle,
    ...reducerGetChatMessages,
    ...reducerSendMessage,
    ...reducerGetChatList,
    ...reducerFindChat,
    ...reducerGetChatListStats,
    ...reducerDeleteChat,
    ...reducerDeleteChatList,
    ...reducerReadChat,
    ...reducerSetChatManager,
    ...reducerCreateMailing,
    ...reducerGetMailingList,
    ...reducerGetMailingUsers,
  },
});
export const { resetGetMailingList, resetGetMailingUsers, resetCreateMailing, resetSetChatManager, resetDeleteChatList, resetDeleteChat, resetGetChatListStats, resetFindChat, resetGetChatList, resetSendMessage, resetGetChatMessages, resetCreateNewMessage, resetGetChatSingle } = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
